import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body mt-10 p-3" }
const _hoisted_2 = { class: "card mb-5 mb-xl-8" }
const _hoisted_3 = { class: "card-header align-items-center" }
const _hoisted_4 = { class: "card-title flex-column" }
const _hoisted_5 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_6 = {
  class: "card-toolbar",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  "data-bs-trigger": "hover",
  title: "Back to articles"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-primary svg-icon-2x" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      /*#__PURE__*/_createElementVNode("polygon", { points: "0 0 24 0 24 24 0 24" }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M6.70710678,15.7071068 C6.31658249,16.0976311 5.68341751,16.0976311 5.29289322,15.7071068 C4.90236893,15.3165825 4.90236893,14.6834175 5.29289322,14.2928932 L11.2928932,8.29289322 C11.6714722,7.91431428 12.2810586,7.90106866 12.6757246,8.26284586 L18.6757246,13.7628459 C19.0828436,14.1360383 19.1103465,14.7686056 18.7371541,15.1757246 C18.3639617,15.5828436 17.7313944,15.6103465 17.3242754,15.2371541 L12.0300757,10.3841378 L6.70710678,15.7071068 Z",
        fill: "#000000",
        "fill-rule": "nonzero",
        transform: "translate(12.000003, 11.999999) scale(-1, 1) rotate(-270.000000) translate(-12.000003, -11.999999) "
      })
    ])
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Back to articles ")
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.article.title), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeArticle'))),
            class: "btn btn-sm btn-light-primary"
          }, _hoisted_9)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", {
          innerHTML: _ctx.article.text
        }, null, 8, _hoisted_11)
      ])
    ])
  ]))
}